export function getItem(key) {
  const now = new Date()

  try {
    const { expiration, value } = JSON.parse(window.localStorage.getItem(key))

    if (value && expiration) {
      const expirationDate = new Date(expiration)

      // If we haven't expired yet, return the value
      if (now < expirationDate) {
        return value
      } else {
        // If we are expired, remove the entry
        window.localStorage.removeItem(key)
        return null
      }
    }
  } catch (error) {
    return null
  }
}

// Expire after 28 days by default
export function setItem(key, value, hoursToExpireAfter = 24 * 28) {
  const now = new Date()
  const expiration = new Date(now.getTime()).setHours(now.getHours() + hoursToExpireAfter)

  try {
    window.localStorage.setItem(key, JSON.stringify({ value, expiration }))
    return value
  } catch (error) {
    throw error
    return null
  }
}
